import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_AD_UNIT_REFRESHER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitRefresher($input: UpdateAdUnitRefresherInput!) {
    updateAdUnitRefresher(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
